import axios from 'axios';

// Keep API_URL exactly the same
export const API_URL = process.env.REACT_APP_API_BASE_URL || '/api';
// Fix only API_URL2 to use a proper fallback value
export const API_URL2 = process.env.REACT_APP_API_BASE_URL2 || 'https://airlineapiv1.azurewebsites.net/api/v1'; 
export const API_KEY = process.env.REACT_APP_API_KEY || 'XgJlPqMbKzVnWyDrFtChSuAe';

// Create a custom Axios instance for the first API (keep it as `apiClient`)
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': API_KEY,
    'Accept': 'text/plain'
  }
});

// Create a custom Axios instance for the second API (new instance `apiClient2`)
const apiClient2 = axios.create({
  baseURL: API_URL2,
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': API_KEY,
    'Accept': 'text/plain'
  }
});

// Add request interceptor for handling CORS and other request configurations
const requestInterceptor = config => {
  // Add CORS headers to requests if needed
  config.headers = {
    ...config.headers,
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,POST,PUT,DELETE,OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, X-API-KEY, Accept'
  };
  
  // Log the request URL for debugging
  console.log('Making API request to:', config.baseURL + (config.url || ''));
  
  return config;
};

apiClient.interceptors.request.use(requestInterceptor);
apiClient2.interceptors.request.use(requestInterceptor);

// Add response interceptor for global error handling
const responseInterceptor = response => response;

const errorInterceptor = error => {
  // Handle common errors
  if (error.response) {
    // Server responded with non-2xx status
    console.error('API Response Error:', error.response.status, error.response.data);
    
    // Handle specific status codes
    switch (error.response.status) {
      case 401:
        console.error('Unauthorized access. Please check API key.');
        break;
      case 403:
        console.error('Access forbidden. Please check permissions.');
        break;
      case 404:
        console.error('Resource not found. Please check the URL.');
        break;
      case 429:
        console.error('Rate limit exceeded. Please try again later.');
        break;
      default:
        console.error('Server error occurred.');
    }
  } else if (error.request) {
    // No response received
    console.error('No response received from server:', error.request);
  } else {
    // Error in setting up request
    console.error('Error setting up request:', error.message);
  }
  
  return Promise.reject(error);
};

apiClient.interceptors.response.use(responseInterceptor, errorInterceptor);
apiClient2.interceptors.response.use(responseInterceptor, errorInterceptor);

export { apiClient, apiClient2 };